import { SxProps, Theme } from "@mui/material";

export const dialogContentSx: SxProps<Theme> = {
  padding: "0 !important",
  backgroundColor: "common.white",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const dialogActionsSx: SxProps<Theme> = {
  justifyContent: "flex-start",
};
